interface CardGridProps {
	children?: React.ReactNode | React.ReactNode[];
}
const CardGrid = ({ children }: CardGridProps) => {
	return <div className="mt-2 flex w-full flex-wrap gap-4">{children}</div>;
};

export default CardGrid;
